import React, { useEffect, useState } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import axios from "axios";
import { BaseUrl } from "../../helper/apiHelper";
import toast from "react-hot-toast";
import { Icon } from "@iconify/react/dist/iconify.js";

const ShipmentRates = () => {
  const [activeTab, setActiveTab] = useState("");
  const [chargesData, setChargesData] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [loading, setLoading] = useState(false);
  const handleCountryChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedCountry(selectedValue);

    const countryMap = {
      "CHINA-INDIA": { from: "CHINA", to: "INDIA" },
      "CHINA-CANADA": { from: "CHINA", to: "CANADA" },
      "INDIA-CANADA": { from: "INDIA", to: "CANADA" },
      "INDIA-USA": { from: "INDIA", to: "USA" },
    };

    if (selectedValue === "") {
      setFrom("");
      setTo("");
    } else if (countryMap[selectedValue]) {
      setFrom(countryMap[selectedValue].from);
      setTo(countryMap[selectedValue].to);
    }
  };

  const tabOptions = [
    { value: "", label: "Select Country" },
    { value: "CHINA-INDIA", label: "CHINA - INDIA" },
    { value: "CHINA-CANADA", label: "CHINA - CANADA" },
    { value: "INDIA-CANADA", label: "INDIA - CANADA" },
    { value: "INDIA-USA", label: "INDIA - USA" },
  ];

  const getShipmentRates = async () => {
    setLoading(true);
    try {
      let body = { from, to, shipping_charges_type: activeTab };
      let response = await axios.post(
        `${BaseUrl}/get-shipping-charges-master-admin`,
        body
      );
      if (response.status === 200) {
        setChargesData(response.data.data);
        setCurrentPage(1);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getShipmentRates();
  }, [activeTab, from, to]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = chargesData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(chargesData.length / itemsPerPage);


  const taxAmmount = (items) => {
    return (
      (items.international_courier_charge +
        items?.local_delivery_charge  * items.taxes/100) 
    );
  }


     function getTotalVal(
       taxPercent,
       internationCharge,
       localCharge,
      
     ) {
       const subtotal = internationCharge + localCharge ;
       const taxAmount = (subtotal * taxPercent) / 100;
       const total = subtotal + taxAmount;
       return total.toFixed(2);
     }




  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Shipment Rates" />
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header py-16 pb-0 px-24 bg-base border border-end-0 border-start-0 border-top-0 d-flex align-items-center flex-wrap justify-content-between">
              <h6 className="text-lg mb-0">Shipping Rates</h6>
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <div
                  className="position-relative"
                  style={{ minWidth: "180px" }}
                >
                  <Icon
                    icon="solar:alt-arrow-down-outline"
                    className="position-absolute"
                    style={{
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      color: "#6c757d",
                      zIndex: 1,
                    }}
                  />
                  <select
                    className="custom-select-no-arrow form-select form-select-sm pe-5 ps-3 rounded border"
                    style={{
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                    }}
                    value={selectedCountry}
                    onChange={handleCountryChange}
                  >
                    {tabOptions.map((tab) => (
                      <option key={tab.value} value={tab.value}>
                        {tab.label}
                      </option>
                    ))}
                  </select>
                </div>
                <ul className="nav bordered-tab d-inline-flex nav-pills mb-0">
                  <li className="nav-item">
                    <button
                      className={`nav-link px-16 py-10 ${
                        activeTab === "" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("")}
                    >
                      ALL
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className={`nav-link px-16 py-10 ${
                        activeTab === "AIR" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("AIR")}
                    >
                      AIR
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className={`nav-link px-16 py-10 ${
                        activeTab === "SHIP" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("SHIP")}
                    >
                      SHIP
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div className="card-body">
              {loading ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    minHeight: "calc(100vh - 300px)",
                    width: "100%",
                    background: "transparent",
                  }}
                >
                  <div
                    className="spinner-border"
                    role="status"
                    style={{
                      color: "#243E85",
                      width: "3rem",
                      height: "3rem",
                    }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : currentItems.length === 0 ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    minHeight: "200px",
                    width: "100%",
                    fontSize: "1.2rem",
                    color: "#243E85",
                    fontWeight: 500,
                  }}
                >
                  No rates found.
                </div>
              ) : (
                <>
                  <div className="table-responsive">
                    <table className="table basic-border-table mb-0">
                      <thead>
                        <tr>
                          <th>International Charge</th>
                          <th>Local Charge</th>
                          <th>Tax</th>
                          <th>Total</th>
                          <th>Shipment Type</th>
                          {!(from && to) && <th>Route (From → To)</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.map((items, index) => (
                          <tr key={index}>
                            <td>${items.international_courier_charge}</td>
                            <td>${items?.local_delivery_charge}</td>
                            <td>{items?.taxes}%</td>
                            <td>
                              $
                              {getTotalVal(
                                items?.taxes,
                                items.international_courier_charge,
                                items?.local_delivery_charge
                              )}
                            </td>
                            <td>{items.shipping_charges_type}</td>
                            {!(from && to) && (
                              <td>{items.from + " -To- " + items.to}</td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {chargesData.length > itemsPerPage && (
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <span>
                        Page {currentPage} of {totalPages}
                      </span>
                      <div className="btn-group">
                        <button
                          className="btn btn-outline-primary"
                          onClick={() =>
                            setCurrentPage((prev) => Math.max(prev - 1, 1))
                          }
                          disabled={currentPage === 1}
                        >
                          Previous
                        </button>
                        <button
                          className="btn btn-outline-primary"
                          onClick={() =>
                            setCurrentPage((prev) =>
                              Math.min(prev + 1, totalPages)
                            )
                          }
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default ShipmentRates;
